type Store = any;

class Logger {
  private static instance: Logger;
  private store: Store | null = null;
  private readonly isProd = import.meta.env.MODE === 'production';
  private constructor() {}

  public static getInstance(): Logger {
    if (!Logger.instance) {
      Logger.instance = new Logger();
    }
    return Logger.instance;
  }

  public injectStore(store: Store) {
    this.store = store;
  }

  log(...args: any[]) {
    this.execute('log', ...args);
  }

  warn(...args: any[]) {
    this.execute('warn', ...args);
  }

  error(...args: any[]) {
    this.execute('error', ...args);
  }

  info(...args: any[]) {
    this.execute('info', ...args);
  }

  debug(...args: any[]) {
    this.execute('debug', ...args);
  }

  table(...args: any[]) {
    this.execute('table', ...args);
  }

  trace(...args: any[]) {
    this.execute('trace', ...args);
  }

  dir(...args: any[]) {
    this.execute('dir', ...args);
  }

  group(...args: any[]) {
    this.execute('group', ...args);
  }

  groupCollapsed(...args: any[]) {
    this.execute('groupCollapsed', ...args);
  }

  groupEnd() {
    console.groupEnd();
  }

  time(label: string) {
    this.execute('time', label);
  }

  timeLog(label: string, ...args: any[]) {
    this.execute('timeLog', label, ...args);
  }

  timeEnd(label: string) {
    this.execute('timeEnd', label);
  }

  count(label?: string) {
    this.execute('count', label);
  }

  countReset(label?: string) {
    this.execute('countReset', label);
  }

  assert(condition: boolean, ...args: any[]) {
    this.execute('assert', condition, ...args);
  }

  clear() {
    console.clear();
  }

  private isAllowedToSeeLogs(): boolean {
    const userInfo = this.store?.getState()?.users?.userInfo;
    return !this.isProd || userInfo?.associated === 1;
  }

  private execute(method: keyof Console, ...args: any[]) {
    if (this.isAllowedToSeeLogs()) {
      (console[method] as Function)(...args);
    }
  }
}

export const logger = Logger.getInstance();
export const injectStore = (store: Store) => logger.injectStore(store);
